__turbopack_context__.v({
  "chevron": "Select-module-scss-module__UoIA-W__chevron",
  "select": "Select-module-scss-module__UoIA-W__select",
  "selectElement": "Select-module-scss-module__UoIA-W__selectElement",
});
